import { Route, Routes } from 'react-router-dom';
import PublicLayout from '../components/layout/PublicLayout/PublicLayout';
import HomePage from '../pages/public/HomePage';
import MedicalDisclaimerPage from '../pages/public/MedicalDisclaimerPage';
import PolicyPage from '../pages/public/PolicyPage';
import ShopPage from '../pages/public/ShopPage';
import CategoriesPage from '../pages/public/CategoriesPage';
import ProductDetailPage from '../pages/public/ProductDetailPage';
import AboutPage from '../pages/public/AboutPage';
import ContactPage from '../pages/public/ContactPage';
import NotFoundPage from '../pages/system/NotFoundPage';
import SystemStatePage from '../pages/system/SystemStatePage';
import RegisterPage from '../pages/auth/RegisterPage';
import LoginPage from '../pages/auth/LoginPage';
import VerificationPendingPage from '../pages/auth/VerificationPage';
import PasswordRecoveryPage from '../pages/auth/PasswordRecoveryPage';
import AccountPage from '../pages/account/AccountPage';
import SecurityPage from '../pages/account/SecurityPage';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import CartPage from '../pages/commerce/CartPage';
import CheckoutPage from '../pages/commerce/CheckoutPage';
import OrdersPage from '../pages/commerce/OrdersPage';
import OrderDetailPage from '../pages/commerce/OrderDetailPage';
import TrackOrderPage from '../pages/commerce/TrackOrderPage';
import AdminPage from '../pages/admin/AdminPage';
import WellnessPage from '../pages/public/WellnessPage';
import AddressesPage from '../pages/account/AddressesPage';
import OrderConfirmationPage from '../pages/commerce/OrderConfirmationPage';
import WishlistPage from '../pages/commerce/WishlistPage';

function AppRoutes() {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route index element={<HomePage />} />
        <Route path="shop" element={<ShopPage />} />
        <Route path="categories" element={<CategoriesPage />} />
        <Route path="wellness" element={<WellnessPage />} />
        <Route path="products/:slug" element={<ProductDetailPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="track-order" element={<TrackOrderPage />} />
        <Route path="search" element={<ShopPage />} />
        <Route path="register" element={<RegisterPage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="verification-pending" element={<VerificationPendingPage />} />
        <Route path="forgot-password" element={<PasswordRecoveryPage />} />
        <Route path="account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
        <Route path="account/security" element={<ProtectedRoute><SecurityPage /></ProtectedRoute>} />
        <Route path="account/orders" element={<ProtectedRoute><OrdersPage /></ProtectedRoute>} />
        <Route path="account/addresses" element={<ProtectedRoute><AddressesPage /></ProtectedRoute>} />
        <Route path="orders/:id" element={<ProtectedRoute><OrderDetailPage /></ProtectedRoute>} />
        <Route path="checkout" element={<ProtectedRoute><CheckoutPage /></ProtectedRoute>} />
        <Route path="order-confirmation/:id" element={<ProtectedRoute><OrderConfirmationPage /></ProtectedRoute>} />
        <Route path="admin" element={<ProtectedRoute roles={['admin']}><AdminPage /></ProtectedRoute>} />
        <Route path="wishlist" element={<WishlistPage />} />
        <Route path="cart" element={<CartPage />} />
        <Route path="medical-disclaimer" element={<MedicalDisclaimerPage />} />
        <Route path="shipping-policy" element={<PolicyPage type="shipping" />} />
        <Route path="cancellation-policy" element={<PolicyPage type="cancellation" />} />
        <Route path="return-refund-policy" element={<PolicyPage type="returns" />} />
        <Route path="privacy" element={<PolicyPage type="privacy" />} />
        <Route path="terms" element={<PolicyPage type="terms" />} />
        <Route path="403" element={<SystemStatePage code="403" description="You do not have permission to view this page." title="Access denied" />} />
        <Route path="500" element={<SystemStatePage code="500" description="An unexpected error occurred. Please try again later." title="Something went wrong" />} />
        <Route path="maintenance" element={<SystemStatePage code="Maintenance" description="The website is temporarily unavailable while essential work is completed." title="We’ll be back soon" />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
